import { ACTION_SET_AUTH_STATUS } from "../auth/names.js";

export default function isAuth(state = false, action) {
  switch (action.type) {
    case ACTION_SET_AUTH_STATUS:
      return action.payload;

    default:
      return state;
  }
}
